"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ClientRequest_1 = __importDefault(require("../ClientRequest"));
const Url_1 = __importDefault(require("../Url"));
const HomeApi = {
    getHomeData: async () => {
        const res = await ClientRequest_1.default.get(Url_1.default.home);
        return res?.data;
    },
    likePost: async (data) => {
        const res = await ClientRequest_1.default.post(`tweets/${data}/likes`);
        return res?.data;
    },
    deleteLikePost: async (data) => {
        const res = await ClientRequest_1.default.delete(`tweets/${data}/likes`);
        return res?.data;
    },
    tweetPostApi: async (data) => {
        const res = await ClientRequest_1.default.post('tweets', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
    tweetEditApi: async (data, dataTweet) => {
        const res = await ClientRequest_1.default.post(`tweets/${data}`, dataTweet, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return res?.data;
    },
    deletePostApi: async (data) => {
        const res = await ClientRequest_1.default.delete(`tweets/${data}`);
        return res?.data;
    },
    NewArticles: async (contentType, data, time) => {
        const res = await ClientRequest_1.default.get(`new-articles?content_type=${contentType}&page=${data}${time ? `&posting_datetime=${time}` : ''}`);
        return res?.data;
    },
    NewArticlesFollow: async (contentType, data, time) => {
        const res = await ClientRequest_1.default.get(`follow-user-articles?content_type=${contentType}&page=${data}${time ? `&posting_datetime=${time}` : ''}`);
        return res?.data;
    },
    hashtagArticles: async (data) => {
        const res = await ClientRequest_1.default.get(`popular-hash-tag-articles?content_type=${data}`);
        return res?.data;
    },
    likeArticles: async (data) => {
        const res = await ClientRequest_1.default.post(`articles/${data}/likes`);
        return res?.data;
    },
    unLikeArticles: async (data) => {
        const res = await ClientRequest_1.default.delete(`articles/${data}/likes`);
        return res?.data;
    },
    getDataTimeLine: async () => {
        const res = await ClientRequest_1.default.get(`timelines`);
        return res?.data;
    },
    HashTagArticle: async (data) => {
        const res = await ClientRequest_1.default.get(`hash-tags/${data?.hashtag}/articles?page=${data.page}&content_type=${data.type}`);
        return res.data;
    },
    HashTagListTweet: async (data) => {
        const res = await ClientRequest_1.default.get(`hash-tags/${data?.hashtag}/tweets?page=${data.page}`);
        return res.data;
    },
    ListTweet: async (data, time) => {
        const res = await ClientRequest_1.default.get(`timelines?page=${data?.page}&per_page=${data?.perpage}${time ? `&created_at=${time}` : ''}`);
        return res?.data;
    },
    HashTagFollowUser: async (data) => {
        const res = await ClientRequest_1.default.get(`hash-tags/${data?.hashtag}/hash-tag-follows?page=${data.page}`);
        return res?.data;
    },
};
exports.default = HomeApi;
